<template>
  <BlockContainer class="p-5">
    <h5>Slette leieobjekt</h5>
    <p v-if="hasActiveSubscription">
      Dette leieobjektet har minst ett aktivt forvaltet leieforhold og kan derfor ikke slettes.
    </p>
    <p v-else>
      Hvis leieobjektet ikke har noen aktive leieforhold er det mulig å slette det ved å klikke på knappen under.
    </p>
    <hl-Button v-if="!hasActiveSubscription" variant="danger" @click="modalOpen = true">Slett leieobjekt</hl-Button>
    <hl-Modal
      v-if="modalOpen"
      class="text-center"
      iconClass="budicon-trash text-danger"
      title="Slette leieobjekt?"
      dismisable
      @close="modalOpen = false"
    >
      <p>Dersom du slette leieobjektet vil det ikke lenger være tilgjengelig i din oversikt.</p>
      <div class="mt-5">
        <hl-Button class="mx-2" variant="danger" :disabled="deleting" :loading="deleting" @click="deleteRentalObject">
          Slett
        </hl-Button>
        <hl-Button class="mx-2" variant="secondary" outline @click="modalOpen = false"> Avbryt </hl-Button>
      </div>
    </hl-Modal>
  </BlockContainer>
</template>

<script>
import BlockContainer from '@/components/BlockContainer.vue';
import { RentalObjectApi } from '@modules/husleieapi2';
import { mapGetters } from 'vuex';
import Modal from '@modules/husleie-framework/src/components/modals/Modal.vue';
import Button from '@modules/husleie-framework/src/components/buttons/Button.vue';

export default {
  name: 'RentalObjectHide',

  components: {
    BlockContainer,
    'hl-Modal': Modal,
    'hl-Button': Button,
  },

  props: {
    landlordId: [String, Number],
    rentalObjectId: [String, Number],
  },

  data() {
    return {
      deleting: false,
      modalOpen: false,
    };
  },

  computed: {
    ...mapGetters(['getRentalObject']),
    rentalObject() {
      return this.getRentalObject(this.rentalObjectId);
    },
    hasActiveSubscription() {
      return this.rentalObject.tenancies.find(tenancy => tenancy.products.find(product => product.status === 'active'));
    },
  },

  methods: {
    async deleteRentalObject() {
      this.deleting = true;
      try {
        const api = new RentalObjectApi();
        await api.deleteLandlordRentalObject(this.landlordId, this.rentalObjectId);
        this.$router.push({ name: 'homeProd', params: { landlordId: this.landlordId } });
      } catch (error) {
        console.error(error);
        this.$toast('Kunne ikke slette leieobjektet', 'error');
      }
      this.deleting = false;
    },
  },
};
</script>

<style scoped lang="scss">
.rental-object-hide {
}
</style>
